import {
    GET_ALL_NEWS,
    GET_ALL_NEWS_SUCCEEDED,
    GET_LAST_NEWS,
    GET_LAST_NEWS_SUCCEEDED,
    GET_LAST_NEWS_FROM_ALL_CATEGORIES,
    GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED,
    GET_NEWS_DETAILS,
    GET_NEWS_DETAILS_SUCCEEDED,
    GET_FAVORITE_NEWS,
    GET_FAVORITE_NEWS_SUCCEEDED,
    ADD_NEWS_TO_FAVORITE,
    ADD_NEWS_TO_FAVORITE_SUCCEEDED,
    ADD_NEWS_COMMENT,
    ADD_NEWS_COMMENT_SUCCEEDED,
    REMOVE_NEWS_FROM_FAVORITE,
    REMOVE_NEWS_FROM_FAVORITE_SUCCEEDED,
    GET_SLIDER_NEWS,
    GET_SLIDER_NEWS_SUCCEEDED,
    GET_NEWS_FROM_CATEGORY,
    GET_NEWS_FROM_CATEGORY_SUCCEEDED,
    GET_NEWS_FROM_CATEGORY_SEE_MORE,
    GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED,
    GET_RECOMMENDED_NEWS,
    GET_RECOMMENDED_NEWS_SUCCEEDED,
    GET_NEWS_CATEGORIES, GET_NEWS_CATEGORIES_SUCCEEDED
} from './types';

export const requestAllNews = (payload) => ({
    type: GET_ALL_NEWS,
    payload,
});

export const requestSliderNews = (payload) => ({
    type: GET_SLIDER_NEWS,
    payload,
});


export const getAllNewsSucceeded = (payload) => ({
    type: GET_ALL_NEWS_SUCCEEDED,
    payload,
});

export const getSliderNewsSucceeded = (payload) => ({
    type: GET_SLIDER_NEWS_SUCCEEDED,
    payload,
});

export const requestLastNews = (payload) => ({
    type: GET_LAST_NEWS,
    payload,
});

export const getLastNewsSucceeded = (payload) => ({
    type: GET_LAST_NEWS_SUCCEEDED,
    payload,
});

export const getLastNewsFromAllCategories = (payload) => ({
    type: GET_LAST_NEWS_FROM_ALL_CATEGORIES,
    payload,
});

export const getLastNewsFromAllCategoriesSucceeded = (payload) => ({
    type: GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED,
    payload,
});

export const getNewsDetails = (payload) => ({
    type: GET_NEWS_DETAILS,
    payload,
    } 
 );

export const getNewsDetailsSucceeded = (payload) => ({
    type: GET_NEWS_DETAILS_SUCCEEDED,
    payload,
});

export const getFavoriteNews = (payload) => ({
    refresh: true,
    type: GET_FAVORITE_NEWS,
    payload
})

export const getFavoriteNewsSucceeded = (payload) => ({
    type: GET_FAVORITE_NEWS_SUCCEEDED,
    payload
})

export const addNewsToFavorite = (payload) => ({
    refresh: true,
    type: ADD_NEWS_TO_FAVORITE,
    payload,
});

export const addNewsToFavoriteSucceeded = (payload) => ({
    type: ADD_NEWS_TO_FAVORITE_SUCCEEDED,
    payload,
});

export const addNewsComment = (payload) => ({
    refresh: true,
    type: ADD_NEWS_COMMENT,
    payload
})

export const addNewsCommentSucceeded = (payload) => ({
    type: ADD_NEWS_COMMENT_SUCCEEDED,
    payload
})

export const removeNewsFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_NEWS_FROM_FAVORITE,
    payload
})

export const removeNewsFromFavoriteSucceeded = (payload) => ({
    type: REMOVE_NEWS_FROM_FAVORITE_SUCCEEDED,
    payload
})

export const getNewsFromCategory = (payload) => ({
    type: GET_NEWS_FROM_CATEGORY,
    payload
})

export const getNewsFromCategorySucceeded = (payload) => ({
    type: GET_NEWS_FROM_CATEGORY_SUCCEEDED,
    payload
})

export const getNewsFromCategorySeeMore = (payload) => ({
    type: GET_NEWS_FROM_CATEGORY_SEE_MORE,
    payload
})

export const getNewsFromCategorySeeMoreSucceeded = (payload) => ({
    type: GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED,
    payload
})

export const getRecommendedNews = (payload) => ({
    type: GET_RECOMMENDED_NEWS,
    payload
})

export const getRecommendedNewsSucceeded = (payload) => ({
    type: GET_RECOMMENDED_NEWS_SUCCEEDED,
    payload
})

export const getNewsCategories = (payload) => ({
    type: GET_NEWS_CATEGORIES,
    payload
})

export const getNewsCategoriesSucceeded = (payload) => ({
    type: GET_NEWS_CATEGORIES_SUCCEEDED,
    payload
})



// WEBPACK FOOTER //
// ./src/SHARED/actions/news.actions.js